<h2 matDialogTitle>Send Quotation</h2>
<mat-dialog-content>
  <div fxLayout="column" [formGroup]="formGroup" fxLayoutGap="12px">
    <div
      class="mt-4 bg-red-300 border-l-4 border-red text-red-700 p-4"
      role="alert"
      *ngIf="!booking.customer.email"
    >
      <p class="font-bold">Warning</p>
      <p>
        There is no email address recorded for this customer.
        <a [routerLink]="['/customer/', booking.customer.id, 'edit']"
          >Add one now</a
        >
      </p>
    </div>

    <div
      class="mt-4 bg-blue-300 border-l-4 border-blue text-blue-700 p-4"
      role="alert"
      *ngIf="!priceMissing"
    >
      <p>
        Please ensure you have the correct charges entered before sending a
        quotation.
      </p>
    </div>

    <div
      class="mt-4 bg-orange-300 border-l-4 border-orange text-orange-700 p-4"
      role="alert"
      *ngIf="priceMissing"
    >
      <p class="font-bold">Warning</p>
      <p>
        One or more items on this booking have not been assigned a charge yet.
      </p>
    </div>

    <div fxLayout="row">
      <mat-form-field fxFlexFill>
        <textarea
          matInput
          cdkTextareaAutosize
          [cdkAutosizeMinRows]="4"
          placeholder="Add a note"
          formControlName="note"
        ></textarea>
      </mat-form-field>
    </div>

    <mat-checkbox (change)="toggleDeposit($event)" [disabled]="!stripeEnabled"
      >Request Deposit</mat-checkbox
    >
    <p *ngIf="!stripeEnabled" class="text-red-700">
      You must configure Stripe before you can request a deposit.
    </p>

    <div fxLayout="column" *ngIf="requestDeposit">
      <p>
        Please enter the deposit amount below, the customer will not be able to
        confirm the booking until the deposit is paid.
      </p>

      <div
        class="mt-4 bg-orange-300 border-l-4 border-orange text-orange-700 p-4"
        role="alert"
        *ngIf="booking.deposit_paid"
      >
        <p class="font-bold">Warning</p>
        <p>This customer has already paid a deposit for this booking.</p>
      </div>

      <mat-form-field>
        <input
          type="number"
          matInput
          placeholder="Deposit Amount"
          autocomplete="off"
          formControlName="deposit_amount"
          min="0"
          required
        />
        <mat-error
          *ngIf="formGroup.controls['deposit_amount'].hasError('required')"
        >
          You must enter a deposit.
        </mat-error>
      </mat-form-field>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close type="button">Cancel</button>

  <button
    mat-flat-button
    color="primary"
    [disabled]="
      !formGroup || !formGroup.valid || saving || !booking.customer.email
    "
    (click)="save()"
  >
    Send
  </button>
</mat-dialog-actions>
